import React, { useState } from 'react';

import TpDialog from '../shared/tp_dialog';
import { discard_guard_text } from '../shared/dialog_logic';
import { DialogFooter, ErrorBox, NoteField } from './dialog_parts';
import { MONTH_PASS_ACTION, note_error } from './params';

/*
 * PROD-7828 A-10b — remove, or give back, a teacher-month's own Free Pass Day with a required reason. Props-only:
 * the Penalties tab's Free Pass box and the Needs Attention row both open it and own the write.
 */
const COPY = {
  [MONTH_PASS_ACTION.REMOVE]: {
    title: "Remove this month's Free Pass Day",
    submit: 'Remove Free Pass Day',
    impact: (name, month) =>
      `${name} will not earn a Free Pass Day for ${month}. The month recalculates. You can give it back while the month is open.`
  },
  [MONTH_PASS_ACTION.RESTORE]: {
    title: "Give back this month's Free Pass Day",
    submit: 'Give it back',
    impact: (name, month) =>
      `${name} earns the Free Pass Day for ${month} again. The month recalculates.`
  }
};

const MonthPassModal = ({
  action,
  teacher_name,
  month_text,
  saving,
  error,
  on_submit,
  on_close,
  on_focus_lost
}) => {
  const [note, setNote] = useState('');
  const [touched, setTouched] = useState(false);
  const copy = COPY[action] || COPY[MONTH_PASS_ACTION.REMOVE];
  const note_err = note_error(note);
  const server = (error && error.fields) || {};

  const submit = () => {
    setTouched(true);
    if (note_err) return;
    on_submit(note);
  };

  return (
    <TpDialog
      title_id="tp-pe-month-pass-title"
      busy={saving}
      guard_text={discard_guard_text(note)}
      on_close={on_close}
      on_focus_lost={on_focus_lost}
    >
      <div className="tp-modal">
        <h4 id="tp-pe-month-pass-title">{copy.title}</h4>
        <div className="tp-ctx">
          <b>{teacher_name}</b> · {month_text}
        </div>
        <div className="tp-hint">{copy.impact(teacher_name, month_text)}</div>
        <NoteField
          id="tp-pe-month-pass-note"
          label="Reason (internal, required)"
          value={note}
          on_change={setNote}
          error_text={(touched && note_err) || server.note}
        />
        <ErrorBox error={error} />
        <DialogFooter
          saving={saving}
          error={error}
          submit_label={copy.submit}
          danger={action === MONTH_PASS_ACTION.REMOVE}
          on_submit={submit}
          on_confirm={submit}
          on_close={on_close}
        />
      </div>
    </TpDialog>
  );
};

export default MonthPassModal;
